var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"save-changes"},[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.save_changes}},[_vm._v("Save Changes")])])]),_c('div',{attrs:{"id":"grid-container"}})])}
var staticRenderFns = []

export { render, staticRenderFns }